import { useState } from "react";
import { motion } from "framer-motion";

/**
 * HeroMascot — Dash, the crowned $ Money Hero. Full-body PNG sits on a
 * radial gold/green spotlight glow over the dark-teal dashboard background.
 * Bouncy Framer Motion entrance: drops down from above, settles with a
 * spring squash-and-stretch, then breathes gently in idle.
 */
const MASCOT_SRC = "/icons/mascot-v2.png";

const containerEntrance = {
  initial: { y: -60, scale: 0.6, opacity: 0 },
  animate: {
    y: 0,
    scale: 1,
    opacity: 1,
    transition: {
      type: "spring",
      stiffness: 220,
      damping: 12,
      mass: 0.9,
      delay: 0.15,
    },
  },
};

// Subtle idle "breathing" loop kicks in after the entrance lands.
const idleLoop = {
  y: [0, -6, 0],
  transition: {
    duration: 3.4,
    ease: "easeInOut",
    repeat: Infinity,
    repeatType: "loop",
    delay: 1.1,
  },
};

export default function HeroMascot({ size = 280 }) {
  const [broken, setBroken] = useState(false);
  return (
    <motion.div
      className="ht-mascot-spotlight"
      data-testid="hero-mascot"
      style={{ width: size + 60, height: size + 60 }}
      variants={containerEntrance}
      initial="initial"
      animate="animate"
    >
      <motion.div
        animate={idleLoop}
        whileHover={{ scale: 1.04, rotate: -2 }}
        whileTap={{ scale: 0.96, rotate: 1 }}
        style={{ width: size, height: size, cursor: "pointer" }}
      >
        {broken ? (
          <div
            className="flex items-center justify-center font-black text-[#22E07A]"
            style={{
              width: size,
              height: size,
              fontSize: size * 0.55,
              fontFamily: "Outfit, sans-serif",
            }}
          >
            $
          </div>
        ) : (
          <img
            src={MASCOT_SRC}
            alt="Dash, the Money Hero mascot"
            className="object-contain drop-shadow-[0_18px_30px_rgba(0,0,0,0.55)]"
            style={{ width: size, height: size, background: "transparent" }}
            onError={() => setBroken(true)}
            draggable={false}
          />
        )}
      </motion.div>
    </motion.div>
  );
}
